// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Zc3G","messages":"Chat_messages__2vUXB","dateDivider":"Chat_dateDivider__1oXDq"};